import { render } from "./CountriesForm.vue?vue&type=template&id=79b0c166"
import script from "./CountriesForm.vue?vue&type=script&lang=js"
export * from "./CountriesForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__